import {
  PROGRAM_SLUG_TO_PROGRAM_DETAILS,
  PROGRAM_SLUG_TO_PROGRAM_ITERATIONS,
} from '@/client/services/programs/config'

import type { TodosSupportedProgramSlug } from '@/components/Worlds/Todos/hooks/programs/types'

import type { TodoItem } from '../../types'
import { useProgramLearnerTodos } from './useProgramLearnerTodos'
import { useProgramTutorTodos } from './useProgramTutorTodos'

// TODO: rename to useProgramWorldTodos to signal that these only work for program subworlds
export function useProgramTodos(programSlug: TodosSupportedProgramSlug): TodoItem[] {
  const { programType, worldSlug } = PROGRAM_SLUG_TO_PROGRAM_DETAILS[programSlug]
  const iterations = PROGRAM_SLUG_TO_PROGRAM_ITERATIONS[programSlug]

  const learnerTodos = useProgramLearnerTodos({ programSlug, worldSlug, programType, iterations })
  const tutorTodos = useProgramTutorTodos({ programSlug, worldSlug, programType, iterations })
  return learnerTodos.concat(tutorTodos)
}
